const MainAPI = {

    esLinks: [
        {
            id: "A",
            name: "প্রধানমন্ত্রীর কার্যালয়",
            link: "http://www.pmo.gov.bd/",
        },
        {
            id: "B",
            name: "জাতীয় ওয়েব পোর্টাল",
            link: "http://www.bangladesh.gov.bd/",
        },
        {
            id: "C",
            name: "জেলা তথ্য বাতায়ন",
            link: "http://www.dcchapainawabganj.gov.bd/",
        },
        {
            name: "মন্ত্রিপরিষদ বিভাগ",
            link: "http://www.cabinet.gov.bd/index.php?lang=bn",
        },
        {
            name: "বিভাগীয় কমিশনারের রাজস্ব আদালত",
            link: "http://demo.xeroneit.net/adc_rajshahi",
        },
        {
            name: "রাষ্ট্রপতির কার্যালয়",
            link: "http://www.bangabhaban.gov.bd/",
        },
        {
            name: "জাতীয় সংসদ",
            link: "http://mopa.gov.bd/",
        },
        {
            name: "সেবাকুঞ্জ",
            link: "http://services.portal.gov.bd",
        },
        {
            name: "তথ্য প্রদানকারী কর্মকর্তা",
            link: "http://www.rajshahidiv.gov.bd/",
        },
        {
            name: "ই-তথ্য কোষ",
            link: "http://www.infokosh.gov.bd",
        },
        {
            name: "তথ্য অধিকার আইন",
            link: "http://bdlaws.minlaw.gov.bd/bangla_all_sections.php?id=1011",
        },
        {
            name: "জাতীয় তথ্য বাতায়ন",
            link: "http://www.bangladesh.gov.bd/www.bangladesh.gov.bd/index16f0.html?q=bn",
        },
        {
            name: "স্থানীয় সরকার বিভাগ",
            link: "http://www.bangladesh.gov.bd/www.bangladesh.gov.bd/index16f0.html?q=bn",
        },
        {
            name: "জনপ্রশাসন মন্ত্রণালয়",
            link: "http://www.bangladesh.gov.bd/www.bangladesh.gov.bd/index16f0.html?q=bn",
        },
        {
            name: "আয়কর নিবন্ধন",
            link: "http://www.bangladesh.gov.bd/www.bangladesh.gov.bd/index16f0.html?q=bn",
        },
    ],
    history: [
        {
            tittle: `পটভূমিকা, নির্বাচন ও সংগঠন:-`,
            para1: `
            জেলা পরিষদ বাংলাদেশের প্রাচীন এক স্থানীয় সরকার ব্যবস্থা। বিভিন্ন সময়ে বিভিন্ন নামে জেলা পরিষদকে অবহিত করা হয়েছে।১৮৮৫ সালে তথানিন্তন বৃটিশ সরকার কর্তৃক স্থানীয় স্বায়ত্ব শাসন আইন ১৮৮৫ পাশ হলে শতাব্দী প্রাচীন রাজশাহী জেলা বোর্ড পরবর্তী বছর অর্থাৎ ১৮৮৬ সালের অক্টোবর মাসে গঠিত হয়। মি: এ, এইচ, রডক্, রাজশাহীর জেলা ম্যাজিষ্টেট পদাধিকার বলে এই নব গঠিত বোর্ডের প্রথম চেয়ারম্যানের আসন অলংকৃত করেন। সরকার কর্তৃক জেলার কিছু গন্যমান্য ভদ্রমহোল এবং উর্দ্ধতন কর্মকর্তাগণ এই বোর্ডের সদস্য মনোনীত হন। এই ভাবে ১৯১৯ সাল পর্যন্ত বিভিন্ন জেলা ম্যাজিষ্ট্রেটগণ জেলা বোর্ডের চেয়ারম্যানের দায়িত্ব পালন করেন।

            অত:পর ১৯২০ সালে জেলা বোর্ডের কার্যকরী কমিটি গঠনের জন্য সমগ্র জেলার প্রথম নির্বাচন অনুষ্ঠিত হয়। উক্ত নির্বাচনে জনাব খান বাহাদুর এমাদুদ্দীন আহমেদ বি, এল, এম, এল, ও বাবু কুমুদ নাথ দত্ত যথাক্রমে জেলা বোর্ডের চেয়ারম্যান ও ভাইস-চেয়ারম্যান নির্বাচিত হন। এছাড়া উক্ত কমিটিতে নিম্ন লিখিত ব্যক্তিবর্গ সদস্য নির্বাচিত ও মনোনীত হন। (উল্লেখ্য যে, ১৯২৬ সালে দ্বিতীয় নির্বাচন অনুষ্ঠিত হয় এবং নির্বাচনে যান বাহদুর এমাদুদ্দীন সাহেব চেয়ারম্যান পদে পূন: নির্বাচতি হন):-
            `,
            para2: `
            এরপর ১৯৩০ সালে জেলা বোর্ডের তৃতীয় নির্বাচন অনুষ্ঠিত হয়। এই নির্বাচনে নাটোরের রাজা বিরেন্দ্র নাথ রায় চেয়ারম্যান নির্বাচিত হন এবং তিনি তার সদস্যদের নিয়ে ১৯৩৫ সাল পর্যন্ত দক্ষতার সাথে দায়িত্ব সম্পাদন করেন।

            পরবর্তীতে ১৯৩৫ সালে জেলা বোর্ডের চতুর্থ বারের নির্বাচন অনুষ্ঠিত হয়। এই নির্বাচনে দিঘাপতিয়ার রাজা প্রমোদ নাথ চেয়ারম্যান নির্বাচিত হন। তিনিও তার সদস্যকে নিয়ে ১৯৪০ সাল পর্যন্ত দক্ষভাবে দায়িত্ব পালনের মাধ্যমে নি:স্বার্থ ভাবে জেলা বোর্ডের সেবা করে যান।

            ১৯৪০ সালে জেলা বোর্ডের প্রথম নির্বাচন অনুষ্ঠিত হয়। উক্ত নির্বাচনে জনাব মনিরুদ্দীন আকন্দ বি,এল, চেয়ারম্যান, জনাব মোবারক আলী বি,এল ১ম ভাইস-চেয়ারম্যান এবং জনাব এম,এস, আবুল কাশেম ২য় ভাইস চেয়ারম্যান নির্বাচিত হয়।
            `,
            para3: `
            এই কমিটি ১৯৫৬ সাল পর্যন্ত সুদীর্ঘ তাঁদের সুনিপুন কর্তব্য পালনের মাধ্যমে জেলা বোর্ডের সেবা করে যান। উল্লেখ্য যে, জনাব মনিরুদ্দীন আকন্দ সুদীর্ঘ প্রায় ১৮ বছর জেলা বোর্ডের চেয়ারম্যানের দায়িত্ব আসীন থাকেন। পরবর্তীকালে তার এই সুদীর্ঘ কাজের নি:স্বার্থ সেবার স্বীকৃতি হিসাবে তাঁর স্মৃতিকে স্মরণ করে রাজশাহী জেলা বোর্ডের একটি রাস্তার নাম “মনিরুদ্দীন আকন্দ রোড” জেলা পরিষদের পুরাতন ভবনের সভাকক্ষের নাম “মনিরুদ্দীন আকন্দ হল” এবং জেলা পরিষদের সম্প্রতি নির্মিত একটি বাজারের নাম “মনি বাজার” রাখা হয়েছিল।

            জেলা বোর্ডের ষষ্ঠ নির্বাচন অনুষ্ঠিত হয় ১৯৫৬ সালে এবং নির্বাচনে জনাব আব্দুল সামাদ ও জনাব মখলেসুর রহমান চৌধুরী যথাক্রমে চেয়ারম্যান ও ভাইস-চেয়ারম্যান এবং নিম্ন লিখিত ব্যক্তিকবর্গ সদস্য নির্বাচিত হন:-
            `,
            para4: `
            ১৯৫৮ সালে দেশে সামরিক আইন বলবত হ’লে এই কমিটি বাতিল করা হয় এবং নির্বাচিত পূর্ব রীতিতে জেলা প্রশাসককে চেয়ারম্যানের দায়িত্ব অর্পন করা হয়।

            ১০ই নভেম্বর, ১৯৫৯ হ’তে রাজশাহী জেলা বোর্ডের চেয়ারম্যান পদের দায়িত্ব রাজশাহী জেলার জেলা প্রশাসক সাহেব পদাধিকার বলে পালন করে যাচ্ছেন। জনাব সামসুর রহমান রাজশাহীর জেলা ম্যাজিষ্ট্রেট সর্বপ্রথম পদাধিকার বলে জেলা বোর্ডের চেয়ারম্যান পদের দায়িত্ব গ্রহণ করেন। ১৯৬০ দশকের প্রথম নিকে বুনিয়াদী গণতন্ত্রের সদস্যদের ভোটে জেলা বোর্ডের সপ্তম নির্বাচন অনুষ্ঠিত হয়। এতে জনাব মজিবর রহমান ভাইস-চেয়ারম্যান এবং নিম্ন লিখিত ব্যক্তিগন সদস্য নির্বাচিত হন। (এতদ্ব্যতীত এই কিমিটিতে পদধিকার বলে মনোনীত সদস্যও ছিলেন):
            `,
            para5: `
            এতপর জেলা বোর্ডের ৮ম নির্বাচন অনুষ্ঠিত হয় ১৯৬০ সালের দ্বিতীয়াদ্ধে। এই নির্বাচনও বি,ডি, মেম্বারগণের ভোটে অনুষ্ঠিত হয়। এরপর আর কোন নির্বাচন অনুষ্ঠিত হয়নি।। এই নির্বাচনে জনাব মখলেসুর রহমান চৌধুরী সদস্যগণের ভোটে ভাইস-চেয়ারম্যান নির্বাচিত হন। নিম্ন বর্ণিত সদস্যবৃন্দের মধ্যে ক্রমিক নং ১ থেকে ১৫ পর্যন্ত বি, ডি, ভোটে নির্বাচিত এবং ক্রমিক নং ১৬ হতে ৩০ পর্যন্ত সদস্যবৃন্দ পদাধিকার বলে মনোনীত হন।
            জেলা প্রশাসক, রাজশাহী চেয়ারম্যান,
            `,
            para6: `           
            বাংলাদেশ স্বাধীন হবার পর জেলা প্রশাসকরাই জেলা পরিষদের দায়িত্ব পালন করেছেন। ১৯৮৮ সালে জেলা পরিষদ আইন হবার পর ঐ বছর অক্টোবর মাসে জনাব মো: মেসবাহ উদ্দিন আহমদকে সরকার রাজশাহী জেলা পরিষদের উপ-মন্ত্রীর মর্যাদায় চেয়ারম্যানের দায়িত্ব প্রদান হয়। জনাব মো: মেসবাহ উদ্দিনের পর অল্প কিছু দিনের জন্য চেয়ারম্যান দয়িত্ব পালন করেন জনাব মো: দুরুল হুদা।

            ২০০০ সালে নতুন করে জেলা পরিষদ আইন প্রণয়ন করা হয়। এরপর ২০০১ সালে থেকে জেলা পরিষদে গণপ্রজাতন্ত্রী বাংলাদেশ সরকার এবং উপ-সচিবকে প্রধান নির্বাহী কর্মকর্তা হিসেবে নিয়োগ করা হয়। ২০১৭ সালে দীর্ঘ দিন পর নির্বাচনের মাধ্যমে রাজশাহী জেলা পরিষদের নিম্নক্ত পরিষদ গঠিত হয়।
            `,
            para7: `
            গত ১১-০১-২০১৭ খ্রি. তারিখ থেকে উল্লিখিত সদস্য এবং চেয়ারম্যানের সমন্বয় রাজশাহী জেলা পরিষদ সত্যতা দক্ষতার সাথে দায়িত্ব পালন করছেন।
            `
        }
    ],
    notice: [
        {
            id: "hgjhfjgfgd",
            tittle: "সংশোধনী লটারী নোটিশ",
            date: "22 Dec 2022",
            pdfURL: "files/notices/No-53.pdf",
        },
        {
            id: "fujhfjhfyujhg",
            tittle: "গাছ বিক্রয়ের দরপত্র স্থগিত করণ বিজ্ঞপ্তি",
            date: "08 Sep 2022",
            pdfURL: "files/notices/No-51.pdf",
        },
        {
            id: "uffyfjughjjh",
            tittle: "১৫ আগষ্ট শোক ‍দিবস উপলক্ষে জেলা পরিষদ, রাজশাহী কর্তৃক গৃহীত কর্মসূচী।",
            date: "14 Aug 2022",
            pdfURL: "files/notices/No-49.pdf",
        },
        {
            id: "kjgiugiukjhk",
            tittle: "গণ বিজ্ঞপ্তি( জেলা পরিষদ, রাজশাহী এর বিভিন্ন ওয়ার্ডের সীমা নির্ধারনের চূড়ান্ত তালিকা)",
            date: "24 Jul 2022",
            pdfURL: "files/notices/No-48.pdf",
        },
        {
            id: "teyrwtgxgfhf",
            tittle: "দরপত্র লটারী সংক্রান্ত",
            date: "17 Jul 2022",
            pdfURL: "files/notices/No-47.pdf",
        },
        {
            id: "uyguyryfuu",
            tittle: "কোটেশন বিজ্ঞপ্তি নং- ০১-২০২২-২০২৩",
            date: "07 Jul 2022",
            pdfURL: "files/notices/No-46.pdf",
        },
        {
            id: "kjgikguiyj",
            tittle: "ঠিকাদারী তালিকাভূক্তি ও নবায়ন বিজ্ঞপ্তি",
            date: "04 Jul 2022",
            pdfURL: "files/notices/No-45.pdf",
        },
        {
            id: "iuguyhgjuytu",
            tittle: "ই-টেন্ডার নোটিশ নং- ই-জিপি-০৫-২০২১-২০২২",
            date: "05 Jul 2022",
            pdfURL: "files/notices/No-44.pdf",
        },
        {
            id: "iuguyhgjuytu",
            tittle: "ই-টেন্ডার নোটিশ নং- ই-জিপি-০1-২০২2-২০২3",
            date: "05 Jul 2022",
            pdfURL: "files/notices/No-52.pdf",
        },
    ],
    oneView: [
        {
            name: "রাজশাহী জেলার আয়তন",
            value: "২৪০৭.০১ বর্গকিলোমিটার",
        },
        {
            name: "উপজেলার সংখ্যা",
            value: "০৯ টি।",
        },
        {
            name: "সিটিকর্পোরেশন",
            value: "০১টি",
        },
        {
            name: "থানার সংখ্যা",
            value: "১৩টি (মেট্রোপলিটন এলাকা-৪টি)",
        },
        {
            name: "ইউনিয়ন পরিষদের সংখ্যা",
            value: "৭১ টি।",
        },
        {
            name: "পৌরসভা",
            value: "১৪ টি।",
        },
        {
            name: "গ্রামের সংখ্যা",
            value: "১৯১৪ টি।",
        },
        {
            name: "মৌজার সংখ্যা",
            value: "১৭১৮ টি।",
        },
        {
            name: "লোকসংখ্যা",
            value: "২৩,৭৭,৩১৪ জন ।",
        },
        {
            name: "ডাকবাংলো",
            value: "১২ টি।",
        },
        {
            name: "মার্কেট/সুপার মার্কেট",
            value: "০১ টি।",
        },
        {
            name: "দোকানের সংখ্যা",
            value: "৫৫ টি",
        },
        {
            name: "৫৫ টি",
            value: "২১ টি।",
        },
        {
            name: "মিলনায়তন/অডিটরিয়াম",
            value: "০৩ টি।",
        },
        {
            name: "ফেরী ঘাট",
            value: "০৪ টি।",
        },
        {
            name: "আন্ত:জেলা ফেরীঘাট",
            value: "০৩ টি।",
        },
        {
            name: "আন্ত: বিভাগীয় ফেরিঘাট",
            value: "০১টি",
        },
        {
            name: "জেলা পরিষদের মোট সম্পত্তি",
            value: `মোট জমি-১৭০০ একর লীজ অযোগ্য  জমি -১৫৮৫ একর লীজ যোগ্য – ১১৫ একর  লীজকৃত জমি-৪৭ একর বেদখল জমি -৭.৩৪ একর`,
        },
    ],
    Survices: [
        {
            name: 'বিভিন্ন ধরনের দাপ্তরিক ও নাগরিক চিঠি পত্র গ্রহন।',
            highTime: 'তাৎক্ষণিক',
            documents: [],
            place: 'সাধারণ শাখ রুম নম্বর-111',
            technic: '___',
            sector: 'সাধারণ শাখ অফিস সহকারী রুম নম্বর-111',
            contact: 'প্রধান নির্বাহী কর্মকর্ত রুম নম্বর-102, টেলিফোন-0721-776348, ইমেইল-zprajshahi@gmail.com',

        },
        {
            name: 'জেলা পরিষদের ব্যবহারযোগ্য জমি একসনা ইজারা / ভাড়া।',
            highTime: '৭ (সাত) কর্মদিবস',
            documents: ['নির্ধারিত ফরমে আবেদন।', 'আবেদনকারীর ২ (কপি) ছবি।', 'জাতীয় পরিচয়পত্রের ছায়ালিপি।', 'প্রযোজ্য ক্ষেত্রে পার্শ্ববর্তী জমির মালিকানা সংক্রান্ত রেকর্ডপত্রের ছায়ালিপি (যদি থাকে) ।'],
            place: 'সাধারণ শাখ রুম নম্বর-107',
            technic: 'আবেদন ফরম-৫০/=(পঞ্চাশ) টাক ভাড়া/ইজারা ফি-নির্ধারিত হারে।',
            sector: 'সাধারণ শাখ সার্ভেয়ার (রুম নম্বর-107)',
            contact: '',

        },
        {
            name: 'বিভিন্ন ধরনের দাপ্তরিক ও নাগরিক চিঠি পত্র গ্রহন।',
            highTime: 'তাৎক্ষণিক',
            documents: [],
            place: 'সাধারণ শাখ রুম নম্বর-111',
            technic: '___',
            sector: 'সাধারণ শাখ অফিস সহকারী রুম নম্বর-111',
            contact: 'প্রধান নির্বাহী কর্মকর্ত রুম নম্বর-102, টেলিফোন-0721-776348, ইমেইল-zprajshahi@gmail.com',

        },
        {
            name: 'বিভিন্ন ধরনের দাপ্তরিক ও নাগরিক চিঠি পত্র গ্রহন।',
            highTime: 'তাৎক্ষণিক',
            documents: [''],
            place: 'সাধারণ শাখ রুম নম্বর-111',
            technic: '___',
            sector: 'সাধারণ শাখ অফিস সহকারী রুম নম্বর-111',
            contact: 'প্রধান নির্বাহী কর্মকর্ত রুম নম্বর-102, টেলিফোন-0721-776348, ইমেইল-zprajshahi@gmail.com',

        },
        {
            name: 'বিভিন্ন ধরনের দাপ্তরিক ও নাগরিক চিঠি পত্র গ্রহন।',
            highTime: 'তাৎক্ষণিক',
            documents: [''],
            place: 'সাধারণ শাখ রুম নম্বর-111',
            technic: '___',
            sector: 'সাধারণ শাখ অফিস সহকারী রুম নম্বর-111',
            contact: 'প্রধান নির্বাহী কর্মকর্ত রুম নম্বর-102, টেলিফোন-0721-776348, ইমেইল-zprajshahi@gmail.com',

        },
        {
            name: 'বিভিন্ন ধরনের দাপ্তরিক ও নাগরিক চিঠি পত্র গ্রহন।',
            highTime: 'তাৎক্ষণিক',
            documents: [''],
            place: 'সাধারণ শাখ রুম নম্বর-111',
            technic: '___',
            sector: 'সাধারণ শাখ অফিস সহকারী রুম নম্বর-111',
            contact: 'প্রধান নির্বাহী কর্মকর্ত রুম নম্বর-102, টেলিফোন-0721-776348, ইমেইল-zprajshahi@gmail.com',

        },
        {
            name: 'বিভিন্ন ধরনের দাপ্তরিক ও নাগরিক চিঠি পত্র গ্রহন।',
            highTime: 'তাৎক্ষণিক',
            documents: [''],
            place: 'সাধারণ শাখ রুম নম্বর-111',
            technic: '___',
            sector: 'সাধারণ শাখ অফিস সহকারী রুম নম্বর-111',
            contact: 'প্রধান নির্বাহী কর্মকর্ত রুম নম্বর-102, টেলিফোন-0721-776348, ইমেইল-zprajshahi@gmail.com',

        },
    ],
    Straps: [
        {
            id: "jhfhgchgdgfg",
            name: 'বীর মুক্তিোদ্ধা মীর ইকবাল',
            posi: 'চেয়ারম্যান',
            phone: '০১৭৪১-৮৯৬৪৫৫',
            photo: 'https://www.zprajshahi.gov.bd/Uploads/chairman-sir1.jpg',
            isSidebar: true,
            bio: [
                {
                    tittle: 'পদবী',
                    info: 'চেয়ারম্যান'
                },
                {
                    tittle: 'মোবাইল নম্বর',
                    info: '০১৭৪১-৮৯৬৪৫৫, ০১৭১১-৩৪৪৬৪১'
                },
                {
                    tittle: 'টেলিফোন নম্বর',
                    info: 'অফিস-০২-৫৮৮৮৫৪১৮৪(অফিস)'
                },
                {
                    tittle: 'ই-মেইল ঠিকানা',
                    info: 'Zprajshahi@Gmail.Com'
                },
                {
                    tittle: 'বর্তমান কর্মস্থলে যোগদানের তারিখ',
                    info: `২২ নভেম্বর ২০২২খ্রি:`
                },
                {
                    tittle: 'নিজ জেলা',
                    info: `রাজশাহী:`
                },
                {
                    tittle: 'রক্তের গ্রুপ',
                    info: `B+`
                },
                {
                    tittle: 'রাজনৈতিক পরিচয়',
                    info: `জাতীয় পরিষদের সদস্য বাংলাদেশ আওয়ামী লীগ সহ-সভাপতি বাংলাদেশ আওয়ামী লীগ, রাজশাহী মহানগর।`
                },
            ]
        },
        {
            id: "jhfjhguyjkhk",
            name: 'মুঃ রেজা হাসান',
            posi: 'প্রধান নির্বাহী কর্মকর্তা',
            phone: '০১৭১৬২০৬১৩৪',
            photo: 'https://www.zprajshahi.gov.bd/Uploads/reza_hasan.jpg',
            isSidebar: true,
            bio: [
                {
                    tittle: 'পদবী',
                    info: 'প্রধান নির্বাহী কর্মকর্তা'
                },
                {
                    tittle: 'মোবাইল নম্বর',
                    info: '০১৭৪১-৮৯৬৪৫৫, ০১৭১১-৩৪৪৬৪১'
                },
                {
                    tittle: 'টেলিফোন নম্বর',
                    info: 'অফিস-০২-৫৮৮৮৫৪১৮৪(অফিস)'
                },
                {
                    tittle: 'ই-মেইল ঠিকানা',
                    info: 'Zprajshahi@Gmail.Com'
                },
                {
                    tittle: 'বর্তমান কর্মস্থলে যোগদানের তারিখ',
                    info: `২২ নভেম্বর ২০২২খ্রি:`
                },
                {
                    tittle: 'নিজ জেলা',
                    info: `রাজশাহী:`
                },
                {
                    tittle: 'রক্তের গ্রুপ',
                    info: `B+`
                },
                {
                    tittle: 'রাজনৈতিক পরিচয়',
                    info: `জাতীয় পরিষদের সদস্য বাংলাদেশ আওয়ামী লীগ সহ-সভাপতি বাংলাদেশ আওয়ামী লীগ, রাজশাহী মহানগর।`
                },
            ]
        },
        {
            name: 'মোঃ এজাজুল আলম',
            posi: 'সহকারী প্রকৌশলী',
            phone: '০১৮২৭১৩৪৮৪১',
            photo: '',
            isSidebar: false,
        },
        {
            name: '',
            posi: 'উপ-সহকারী প্রকৌশলী',
            phone: '',
            photo: '',
            isSidebar: false,
        },
        {
            name: 'মো: আফজালুর রহমান',
            posi: 'প্রধান সহকারী',
            phone: '০১৭১৬-৬৯৫৬৫৪',
            photo: '',
            isSidebar: false,
        },
        {
            name: '',
            posi: 'হিসাব রক্ষক',
            phone: '০১৭১৬২০৬১৩৪',
            photo: '',
            isSidebar: false,
        },
        {
            name: 'মোঃ আইয়ুবুর রহমান',
            posi: 'উচ্চমান সহকারী',
            phone: '০১৭২১-৩২০২৯৮',
            photo: '',
            isSidebar: false,
        },
        {
            name: 'এস. এম. আল মতিন',
            posi: 'উচ্চমান সহকারী',
            phone: '০১৭১৭-০০৮৩৫৯',
            photo: '',
            isSidebar: false,
        },
        {
            name: 'এম ডি আসলাম হোসেন',
            posi: 'নিম্মমান সহকারী-কাম-মুদ্রাক্ষরিক /কম্পিউটার অপারেটর',
            phone: '০১৭১৬-৫৪৭৩৭১',
            photo: '',
            isSidebar: false,
        },
        {
            name: '',
            posi: 'নিম্মমান সহকারী-কাম-মুদ্রাক্ষরিক /কম্পিউটার অপারেটর',
            phone: '',
            photo: '',
            isSidebar: false,
        },
        {
            name: 'মো: আলেফ আলী',
            posi: 'সার্ভেয়ার',
            phone: '০১৭৮১-৩২৮৫৪২',
            photo: '',
            isSidebar: false,
        },
        {
            name: 'মো: আফতাব উদ্দিন (বাবু)',
            posi: 'ইলেকট্রিশিয়ান',
            phone: '০১৮২২৬৬৯০১০',
            photo: '',
            isSidebar: false,
        },
        {
            name: 'শ্রী উত্তম কুমার ঘোষ',
            posi: 'ড্রাইভার',
            phone: '০১৭১৪-৬০৪৫৩২',
            photo: '',
            isSidebar: false,
        },
        {
            name: 'মো: আফজাল হোসেন',
            posi: 'ড্রাইভার',
            phone: '০১৭১৬-০৯১০৬৫',
            photo: '',
            isSidebar: false,
        },
        {
            name: 'মো: রবিউল ইসলাম',
            posi: 'রোলার ড্রাইভার',
            phone: '০১৭১৮-৩১৯৬৫৬',
            photo: '',
            isSidebar: false,
        },
        {
            name: 'মো: নজরুলইসলাম ',
            posi: '(অফিস সহায়ক)',
            phone: '০১৯১৮-৭৪৪৬৮১',
            photo: '',
            isSidebar: false,
        },
        {
            name: 'শ্রী সোনাতন চন্দ্র দাস',
            posi: '(অফিস সহায়ক)',
            phone: '০১৯৩২-৭২৫৫৯৭',
            photo: '',
            isSidebar: false,
        },
        {
            name: 'মো: ছালাম উদ্দিন',
            posi: 'নৈশ প্রহরী',
            phone: '০১৭৭২-১৭৬২৪১',
            photo: '',
            isSidebar: false,
        },
        {
            name: '	বাবু  সরকার',
            posi: '(সুইপার) ',
            phone: '০১৩১৬-৮৩৯৪৫৩',
            photo: '',
            isSidebar: false,
        },
    ],
    Members: [
        {
            name: 'শ্রীমতি শিউলী রানী সাহা',
            posi: 'সংরক্ষিত সদস্য- 01',
            upozela: '‡Mv`vMvox, Zv‡bvi I cev',
            phone: '01739-956197',
        },
        {
            name: 'শ্রীমতি শিউলী রানী সাহা',
            posi: 'সংরক্ষিত সদস্য- 01',
            upozela: '‡Mv`vMvox, Zv‡bvi I cev',
            phone: '01739-956197',
        },
        {
            name: 'শ্রীমতি শিউলী রানী সাহা',
            posi: 'সংরক্ষিত সদস্য- 01',
            upozela: '‡Mv`vMvox, Zv‡bvi I cev',
            phone: '01739-956197',
        },
        {
            name: 'শ্রীমতি শিউলী রানী সাহা',
            posi: 'সংরক্ষিত সদস্য- 01',
            upozela: '‡Mv`vMvox, Zv‡bvi I cev',
            phone: '01739-956197',
        },
        {
            name: 'শ্রীমতি শিউলী রানী সাহা',
            posi: 'সংরক্ষিত সদস্য- 01',
            upozela: '‡Mv`vMvox, Zv‡bvi I cev',
            phone: '01739-956197',
        },
    ],
    ServInfo: [
        // {
        //     tittle: "সামাজিক কাজ",
        //     logo: "/imgs/seba.jpg",
        //     list: [
        //         {
        //             tittle: "শিক্ষাবৃত্তি",
        //             path: "/Survices",
        //         },
        //         {
        //             tittle: "আর্থিক সহযোগিতা",
        //             path: "/Survices",
        //         },
        //         {
        //             tittle: "প্রশিক্ষণ",
        //             path: "/Survices",
        //         }, 
        //     ],
        // },
        {
            tittle: "বার্ষিক কর্মসম্পাদন চুক্তি",
            logo: "/imgs/apa.png",
            list: [
                {
                    tittle: "এপিএ নির্দেশিকা/পরিপত্র/এপিএ টিম",
                    path: "/Survices",
                },
                {
                    tittle: "চুক্তিসমূহ",
                    path: "/Survices",
                },
                {
                    tittle: "পরিবীক্ষণ ও মূল্যায়ন প্রতিবেদন",
                    path: "/Survices",
                },
            ]
        },
        {
            tittle: "তথ্য অধিকার",
            logo: "/imgs/RTI.png",
            list: [
                {
                    tittle: "তথ্য প্রদানকারী কর্মকর্তা",
                    path: "/totho-prodankari",
                },
                {
                    tittle: "বিকল্প তথ্য প্রদানকারী কর্মকর্তা",
                    path: "/Survices",
                },
                {
                    tittle: "আপীল কর্তৃপক্ষ",
                    path: "/Survices",
                },
            ]
        },
        {
            tittle: "শুদ্ধাচার কৌশল কর্মপরিকল্পনা",
            logo: "/imgs/NIS.png",
            list: [
                {
                    tittle: "শুদ্ধাচার কৌশল কর্মপরিকল্পনা",
                    path: "/Survices",
                },
                {
                    tittle: "ফোকাল পয়েন্ট ও বিকল্প কর্মকর্তা",
                    path: "/Survices",
                },
                {
                    tittle: "ত্রৈমাসিক/ষাণ্মাসিক পরিবীক্ষণ প্রতিবেদন",
                    path: "/Survices",
                },
            ]
        },
        {
            tittle: "বাজেট",
            logo: "/imgs/BUDGET.png",
            list: [
                {
                    tittle: "চলমান বাজেট",
                    path: "/Survices",
                },
                {
                    tittle: "সংশোধিত বাজেট",
                    path: "/Survices",
                },
                {
                    tittle: "পূর্ববর্তী বাজেট",
                    path: "/Survices",
                },
            ]
        },
        {
            tittle: "প্রকল্পসমূহ",
            logo: "/imgs/others.jpg",
            list: [
                {
                    tittle: "অগ্রগতির বিবরণ",
                    path: "/Survices",
                },
                {
                    tittle: "চলমান প্রকল্পসমূহ",
                    path: "/Survices",
                },
                {
                    tittle: "পূর্ববর্তী প্রকল্পসমূহ",
                    path: "/Survices",
                },
            ]
        },
    ],
    ZPwork: [
        {
            tittle: "জেলা পরিষদ আইন-২০০০ অনুযায়ী জেলা পরিষদের কার্যাবলী",
            tittle2: "প্রথম তফসিল প্রথম অংশ বাধ্যতামঞ্ঝলক কার্যাবলী [ধারা ২৭(২) দ্রষ্টব্য]",
            para: "১। জেলার সকল উন্নয়ন কার্যক্রমের পর্যালোচনা। ২। উপজেলা পরিষদ ও পৌরসভা কর্তৃক গৃহীত উন্নয়ন প্রকল্পসমঞ্ঝহের বা¯èবায়ন অগ্রগতি পর্যালোচনা। ৩। সাধারণ পাঠাগারের ব্যবস্থা ও উহার রক্ষণাবেক্ষণ। ৪। উপজেলা পরিষদ, পৌরসভা বা সরকার কর্তৃক সংরক্ষিত নহে এই প্রকার জনপথ, কালভার্ট ও ব্রীজ এর নির্মাণ, রক্ষণাবেক্ষণ এবং উন্নয়ন। ৫। রা¯èার পার্শ্বে ও জনসাধারণের ব্যবহার্য স্থানে বৃক্ষরোপণ ও উহার সংরক্ষণ। ৬। জনসাধারণের ব্যবহারার্থে উদ্যান, খেলার মাঠ ও উন্মুক্ত স্থানের ব্যবস্থা ও উহাদের রক্ষণাবেক্ষণ। ৭। সরকারী, উপজেলা পরিষদ বা পৌরসভার রক্ষণাবেক্ষণে নহে এমন খেয়াঘাটের ব্যবস্থাপনা ও নিযšল্গণ। ৮। সরাইখানা, ডাকবাংলা এবং বিশ্রামাগারের ব্যবস্থা ও রক্ষণাবেক্ষণ। ৯। জেলা পরিষদের অনুরূপ কার্যাবলী স¤ক্সাদনরত অন্যান্য প্রতিষ্ঠানের সংগে সহযোগিতা। ১০। উপজেলা ও পৌরসভাকে সহায়তা, সহযোগিতা এবং উৎসাহ প্রদান। ১১। সরকার কর্তৃক জেলা পরিষদের উপর অর্পিত উন্নয়ন পরিকল্পনার বা¯èবায়ন। ১২। সরকার কর্তৃক আরোপিত অন্যান্য কাজ।"
        },
        {
            tittle1: "দ্বিতীয় অংশ ঐচ্ছিক কার্যাবলী [ধারা ২৭(৩) দ্রষ্টব্য]",
            tittle2: "(ক) শিক্ষা",
            para: "১। বিদ্যালয় স্থাপন ও রক্ষণাবেক্ষণ। ২। ছাত্রাবাসের জন্য দালান নির্মাণ ও রক্ষণাবেক্ষণ। ৩। ছাত্র বৃত্তির ব্যবস্থা। ৪। শিক্ষক প্রশিক্ষণ। ৫। শিক্ষা প্রতিষ্ঠানে অর্থ মঞ্জুরী প্রদান। ৬। শিক্ষামূলক জরিপ গ্রহণ, শিক্ষা পরিকল্পনা প্রণয়ন এবং উহার বাস্তবায়ন। ৭। শিক্ষা উন্নয়নের লক্ষ্যে গঠিত সমিতিসমূহের উন্নয়ন ও সাহায্য। ৮। উপানুষ্ঠানিক শিক্ষা উন্নয়ন। ৯। স্কুলের শিশু-ছাত্রদের জন্য দুগ্ধ সরবরাহ ও খাদ্যের ব্যবস্থা। ১০। বই প্রকাশনা ও ছাপাখানা বেক্ষণাবেক্ষণ। ১১। এতিম ও দুঃস্থ ছাত্রদের জন্য বিনা মূল্যে অথবা কম মূল্যে পাঠ্য পুস্তকের ব্যবস্থা। ১২। স্কুলের বই এবং ষ্টেশনারী মাল বিক্রয় কেন্দ্র রক্ষণাবেক্ষণ। ১৩। শিক্ষার উন্নয়নের সহায়ক অন্যান্য ব্যবস্থা গ্রহণ।",
        },
        {
            tittle2: "(খ)  সংস্কূতি",
            para: `১৪। তথ্যকেন্দ্র স্থাপন ও রক্ষণাবেক্ষণ। ১৫। সাধারণ সাংস্কৃতিমূলক কর্মকান্ড সংগঠন। ১৬। জনসাধারণের জন্য ক্রীড়া ও খেলাধুলা উন্নয়ন। ১৭। সরকারী প্রতিষ্ঠান এবং জনসাধারণের ব্যবহার্য ¤হানে রেডিও ও টেলিভিশন এর ব্যবস্থা ও রক্ষণাবেক্ষণ। ১৮। যাদুঘর ও আর্ট-গ্যালারি স্থাপন ও প্রদর্শনীর সংগঠন।

            ১৯। পাবলিক হল, কমিউনিটি সেন্টার প্রতিষ্ঠান এবং জনসভার জন্য স্থানের ব্যবস্থা। ২০। নাগরিক শিক্ষার প্রসার এবং স্থানীয় সরকার, পল্লী উন্নয়ন ও পুনর্গঠন, স্বাস্থ্য, সমাজ উন্নয়ন, কৃষি শিক্ষা, গবাদি পশু প্রজনন সম্পর্কিত এবং জনস্বার্থ সম্পর্কিত অন্যান্য বিষয়ের উপর তথ্য প্রচার। ২১। মহানবী (সঃ) এর জন্মদিবস, জাতীয় দিবস, জাতীয় শোক দিবস, শহীদ দিবস ও অন্যান্য জাতীয় অনুষ্ঠান উদ্যাপন। ২২। বিশিষ্ট অতিথিগণের অভ্যর্থনা। ২৩। শরীর চর্চ্চার উন্নয়ন, খেলাধুলায় উৎসাহ দান এবং সমাবেশ ও প্রতিযোগিতামূলক ক্রীড়া ও খেলাধুলার ব্যবস্থা করা। ২৪। স্থানীয় এলাকার ঐতিহাসিক এবং আদি বৈশিষ্ট্যসমূহ সংরক্ষণ। ২৫। সংস্কৃতি উন্নয়নমূলক অন্যান্য ব্যবস্থা।`
        },
        {
            tittle2: "গ) সমাজ কল্যাণ",
            para: "২৬। দুঃস্থ ব্যক্তিদের জন্য কল্যাণ সদন, আশ্রয় সদন, এতিমখানা, বিধবা সদন এবং অন্যান্য প্রতিষ্ঠান স্থাপন ও রক্ষণাবেক্ষণ। ২৭। মৃত নিঃস্ব ব্যক্তিদের দাফনের ও অšেèাষ্টিক্রিয়ার ব্যবস্থা করা। ২৮। ভিক্ষাবৃত্তি, পতিতাবৃত্তি, জুয়া, মাদকদ্রব্য সেবন, মদ্যপান, কিশোর অপারধ এবং অন্যান্য সামাজিক অনাচার প্রতিরোধ। ২৯। জনগণের মধ্যে সামাজিক, নাগরিক এবং দেশপ্রেমমূলক গুণাবলী উন্নয়ন এবং গৌত্র বা গোষ্ঠিগত, বর্ণগত এবং স¤ক্স্রদায়গত কুসংস্কার নিরুৎসাহিত করা। ৩০। সমাজ সেবার জন্য স্বেচ্ছাসেবকদের সংগঠিত করণ। ৩১। দরিদ্রদের জন্য আইনগত সহায়তা। ৩২। নারী ও পশ্চাদপদ শ্রেণীর পরিবারের সদস্যদের কল্যাণমূলক কার্যক্রম গ্রহণ। ৩৩। সালিশী ও আপোষের মাধ্যমে বিরোধ নি¯ক্সত্তির ব্যবস্থা গ্রহণ। ৩৪। সমাজকল্যাণ ও সমাজ উন্নয়নমূলক অন্যান্য ব্যবস্থা গ্রহণ।",
        },
        {
            tittle2: "ঘ) অর্থনৈতিক কল্যাণ",
            para: "৩৫। আদর্শ কৃষিখামার স্থাপন ও রক্ষণাবেক্ষণ। ৩৬। উন্নত কৃষি পদ্ধতি জনপ্রিয়করণ, উন্নত কৃষি যন্ত্রপাতির সংরক্ষণ ও কৃষকগণকে উক্ত যন্ত্রপাতির ধারে প্রদান এবং পতিত জমি চাষের জন্য ব্যবস্থা গ্রহণ। ৩৭। শস্য পরিসংখ্যান সংরক্ষণ, ফসলের নিরাপত্তা বিধান, বপনের উদ্দেশ্যে বীজের ঋণদান, রাসায়নিক সার বিতরণ এবং উহার ব্যবহার জনপ্রিয়করণ এবং পশু খাদ্যের মওজুদ গড়িয়া তোলা। ৩৮। কৃষি ঋণ প্রদান ও কৃষি শিক্ষার উন্নয়ন এবং কৃষি উন্নয়নমূলক অন্যান্য ব্যবস্থা গ্রহণ। ৩৯। বাঁধ নির্মাণ ও মেরামত এবং কৃষি কাজে ব্যবহার্য পানি সরবরাহ, জমানো ও নিয়šল্গণ। ৪০। গ্রামাঞ্চলে বনভূমি সংরক্ষণ। ৪১। ভূমি সংরক্ষণ ও পুনরুদ্ধার এবং জলাভূমির পানি নিস্কাশন। ৪২। বাজার স্থাপন, নিয়šল্গণ এবং রক্ষণাবেক্ষণ। ৪৩। গ্রামাঞ্চলের শিল্পসমূহের জন্য কাঁচামাল সংগ্রহ এবং উৎপাদিত সামগ্রির বাজারজাত করণের ব্যবস্থা। ৪৪। শিল্প-স্কুল স্থাপন, সংরক্ষণ এবং গ্রামভিত্তিক শিল্পের জন্য শ্রমিকদের প্রশিক্ষণ প্রদান। ৪৫। গ্রাম্য বিপণী স্থাপন ও সংরক্ষণ। ৪৬। সমবায় আন্দোলন জনপ্রিয়করণ ও সমবায় শিক্ষার উন্নতি সাধন। ৪৭। অর্থনৈতিক কল্যাণের জন্য অন্যান্য ব্যবস্থা গ্রহণ। জনস্বাস্থ্য ৪৮। জনস্বাস্থ্য বিষয়ক শিক্ষার উন্নয়ন। ৪৯। ম্যালেরিয়া ও সংক্রামক ব্যাধি প্রতিরোধ ও নিয়šল্গণের জন্য প্রকল্প প্রণয়ন ও বাস্তবায়ন। ৫০। প্রাথমিক চিকিৎসা কেন্দ্র স্থাপন ও রক্ষণাবেক্ষণ। ৫১। ভ্রাম্যমান চিকিৎসক দল গঠন। ৫২। চিকিৎসা সাহায্য প্রদানের জন্য সমিতি গঠনে উৎসাহ দান। ৫৩। চিকিৎসা-শিক্ষার উন্নয়ন এবং চিকিৎসা সাহায্যদানকারী প্রতিষ্ঠানসমূহে অর্থ মঞ্জুরী প্রদান। ৫৪। ক¤ক্সউন্ডার, নার্স এবং অন্যান্য চিকিৎসা কর্মীদের কাজ ও ডেসপেনসারী পরিদর্শন। ৫৫। ইউনানী, আয়ুর্বেদীয় ও হোমিওপ্যাথিক ডিসপেনসারী প্রতিষ্ঠা, রক্ষণাবেক্ষণ ও পরিদর্শন। ৫৬। স্বাস্থ্য কেন্দ্র, মাতৃসদন ও শিশু মংগল কেন্দ্র স্থাপন, রক্ষণাবেক্ষণ ও পরিদর্শন, ধাত্রীদের প্রশিক্ষণ দান এবং মাতা ও শিশুদের কল্যাণের জন্য অন্যান্য ব্যবস্থা গ্রহণ। ৫৭। পশু-পাখীর ব্যাধি দঞ্ঝরীকরণ এবং পশু-পাখীদের মধ্যে ছোঁয়াচে রোগের প্রতিরোধ ও নিয়šল্গণ। ৫৮। গবাদি পশু স¤ক্সদ সংরক্ষণ। ৫৯। চারণভূমির ব্যবস্থা ও উন্নয়ন। ৬০। দুগ্ধ সরবরাহ নিয়šল্গণ, দুগ্ধপল্লী স্থাপন এবং স্বাস্থ্যসম্মত আ¯èাবলের ব্যবস্থা ও নিয়šল্গণ। ৬১। গবাদি খামার ও দুগ্ধ খামার স্থাপন ও সংরক্ষণ। ৬২। হাঁস মুরগীর খামার স্থাপন ও সংরক্ষণ। ৬৩। জনস্বাস্থ্য, পশুপালন ও পাখী কল্যাণ উন্নয়নের জন্য অন্যান্য ব্যবস্থা গ্রহণ।",
        },
        {
            tittle2: "ঙ) গণপূর্ত",
            para: "৬৪। যোগাযোগ ব্যবস্থার উন্নতি সাধন। ৬৫। পানি নিস্কাশন পানি সরবরাহ ব্যবস্থা, ভূ-উপরিস্থ সুপেয় পানির জলাশয় সংরক্ষণ, বৃষ্টির পানি সংরক্ষণ, রা¯èা পাকাকরণ ও অন্যান্য জনহিতকর অত্যাবশ্যকীয় কাজ করা। ৬৬। স্থানীয় এলাকার নক্শা প্রণয়ন। ৬৭। এই আইন বা অন্য কোন আইনের অধীনে ন্যাস্ত কোন দায়িত্ব পালনের জন্য প্রয়োজনীয় অথচ এই আইনের অন্যত্র উলেখ নাই এমন জনকল্যাণমূলক অত্যাবশ্যকীয় কাজের নির্মাণ ও ব্যবস্থাপনা।",
        },
        {
            tittle2: "ছ) সাধারণ",
            para: "৬৮। স্থানীয় এলাকা ও উহার অধিবাসীদের ধর্মীয়, নৈতিক ও বৈষয়িক উন্নতি সাধনের জন্য ব্যবস্থা গ্রহণ।",
        }
    ],
    TopLink: {
        typeof: [
            {
                tittle: "অফিসের ধরণ",
                value: ""
            },
            {
                tittle: "মন্ত্রণালয়/বিভাগ",
                value: "ministry"
            },
            {
                tittle: "অধিদপ্তর বাতায়ন",
                value: "directorate"
            },
            {
                tittle: "বিভাগীয় বাতায়ন",
                value: "divisional"
            },
            {
                tittle: "জেলা বাতায়ন",
                value: "districal"
            },
            {
                tittle: "উপজেলা বাতায়ন",
                value: "upazilaBatayon"
            },
            {
                tittle: "ইউনিয়ন বাতায়ন",
                value: "unionBatayon"
            },
            {
                tittle: "অন্যান্য",
                value: "otherOfficeList"
            },
        ],
        ministry: [
            {
                tittle: "মন্ত্রণালয় ধরণ",
                value: "",
            },
            {
                tittle: "রাষ্ট্রপতির কার্যালয়",
                value: "https://bangabhaban.gov.bd/",
            },
            {
                tittle: "গণপ্রজাতন্ত্রী বাংলাদেশ সরকার",
                value: "http://pmo.gov.bd/",
            },
            {
                tittle: "মন্ত্রিপরিষদ বিভাগ",
                value: "http://cabinet.gov.bd/",
            },
            {
                tittle: "মাধ্যমিক ও উচ্চ শিক্ষা বিভাগ",
                value: "http://shed.gov.bd/",
            },
            {
                tittle: "কারিগরি ও মাদ্রাসা শিক্ষা বিভাগ",
                value: "http://tmed.gov.bd/",
            },
            {
                tittle: "গৃহায়ন ও গণপূর্ত মন্ত্রণালয়",
                value: "http://mohpw.gov.bd/",
            },
            {
                tittle: "জনপ্রশাসন মন্ত্রণালয়",
                value: "https://mopa.gov.bd/",
            },
            {
                tittle: "ভূমি মন্ত্রণালয়",
                value: "http://minland.gov.bd/",
            },
            {
                tittle: "পার্বত্য চট্টগ্রাম বিষয়ক মন্ত্রণালয়",
                value: "http://mochta.gov.bd/",
            },
            {
                tittle: "বেসামরিক বিমান পরিবহন ও পর্যটন মন্ত্রণালয়",
                value: "http://mocat.gov.bd/",
            },
            {
                tittle: "আইন ও বিচার বিভাগ",
                value: "http://lawjusticediv.gov.bd/",
            },
            {
                tittle: "লেজিসলেটিভ ও সংসদ বিষয়ক বিভাগ",
                value: "http://legislativediv.gov.bd/",
            },
            {
                tittle: "সমাজকল্যাণ মন্ত্রণালয়",
                value: "http://msw.gov.bd/",
            },
            {
                tittle: "কৃষি মন্ত্রণালয়",
                value: "http://moa.gov.bd/",
            },
            {
                tittle: "স্বাস্থ্য সেবা বিভাগ",
                value: "http://hsd.gov.bd/",
            },
            {
                tittle: "স্বাস্থ্য শিক্ষা ও পরিবার কল্যাণ বিভাগ",
                value: "http://mefwd.gov.bd/",
            },
            {
                tittle: "পররাষ্ট্র মন্ত্রণালয়",
                value: "http://mofa.gov.bd/",
            },
            {
                tittle: "মহিলা ও শিশু বিষয়ক মন্ত্রণালয়",
                value: "",
            },
            {
                tittle: "বস্ত্র ও পাট মন্ত্রণালয়",
                value: "",
            },
            {
                tittle: "বিদ্যুৎ বিভাগ",
                value: "",
            },
        ],
        directorate: [
            {
                tittle: "অধিদপ্তর ধরণ",
                value: "",
            },
        ],
        divisional: [
            {
                tittle: "বিভাগীয় ধরণ",
                value: "",
            },
        ],
        districal: [
            {
                tittle: "জেলা ধরণ",
                value: "",
            },
        ],
        upazilaBatayon: [
            {
                tittle: "উপজেলা ধরণ",
                value: "",
            },
        ],
        unionBatayon: [
            {
                tittle: "ইউনিয়ন ধরণ",
                value: "",
            },
        ],
        otherOfficeList: [
            {
                tittle: "অন্যান্য ধরণ",
                value: "",
            },
        ],
    }
}


export default MainAPI
